/* ==========================================================================
   BJW Health theme - core JavaScript (vanilla, no build step)
   Loaded with `defer` from layout/theme.liquid.

   Provides:
   - Drawer / dialog toggling via data attributes
       <button data-drawer-open="MobileMenu">  opens  <div id="MobileMenu" class="drawer">
       <button data-drawer-close>              closes the drawer it sits in
   - Escape-to-close and a simple focus trap
   - window.BJW.publish / subscribe: tiny event bus used by cart and search code
   ========================================================================== */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var openDrawer = null;
  var lastTrigger = null;

  /* ---------- Event bus ---------- */
  var listeners = {};
  var BJW = (window.BJW = window.BJW || {});
  BJW.subscribe = function (name, fn) {
    (listeners[name] = listeners[name] || []).push(fn);
  };
  BJW.publish = function (name, detail) {
    (listeners[name] || []).forEach(function (fn) { fn(detail); });
  };

  /* ---------- Drawers ---------- */
  BJW.openDrawer = function (el, trigger) {
    if (!el) return;
    if (openDrawer && openDrawer !== el) BJW.closeDrawer();
    lastTrigger = trigger || document.activeElement;
    el.hidden = false;
    // next frame so CSS transitions run after `hidden` is removed
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.documentElement.classList.add('no-scroll');
    openDrawer = el;
    var first = el.querySelector('[data-autofocus]') || el.querySelector(FOCUSABLE);
    if (first) first.focus();
    BJW.publish('drawer:open', { id: el.id });
  };

  BJW.closeDrawer = function () {
    if (!openDrawer) return;
    var el = openDrawer;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('no-scroll');
    setTimeout(function () { el.hidden = true; }, 250);
    openDrawer = null;
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    BJW.publish('drawer:close', { id: el.id });
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      BJW.openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      BJW.closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openDrawer) return;
    if (e.key === 'Escape') { BJW.closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var items = openDrawer.querySelectorAll(FOCUSABLE);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
